const brandMenu = {
  key: 'brand',
  caption: 'Brand',
  subMenuItems: [
    {
      key: 'brand-toyota',
      caption: 'Toyota',
      onClick: () => {},
    },
    {
      key: 'brand-lexus',
      caption: 'Lexus',
      onClick: () => {},
    },
  ],
};

export default brandMenu;
